import { CacheService } from '@/service/utils/cache';

export const useCacheStore = defineStore('cache', () => {
    const cache = shallowRef(new Map());
    const timers = shallowRef([]);

    const service = new CacheService({
        cache: cache.value,
        timers: timers.value
    });

    const set: typeof service.set = (params) => {
        service.set(params);
        triggerRef(cache);
        triggerRef(timers);
    };

    const get: typeof service.get = (params) => {
        return service.get(params);
    };

    const remove: typeof service.delete = ({ key }) => {
        service.delete({ key });
        triggerRef(cache);
        triggerRef(timers);
    };

    return {
        service,
        cache,
        set,
        remove,
        get
    } as const;
});
